import {GeneralAction} from "../../../@types/actions";
import {InstantDropObject} from "../../../@types/formContext";
import {NEW_EVENT_CHANGE} from "../../../constants/OddsConstants";

export const NewDropAction = (data: InstantDropObject): GeneralAction<InstantDropObject> => ({
    type: NEW_EVENT_CHANGE,
    payload: data
});
